import { PencilSimple } from '@phosphor-icons/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useUserPermissions } from 'auth/hooks';
import { Button } from 'core/components';
import { AccessPermissions } from 'core/enums';
import { IPartDetails, IPartManufacturer } from 'parts/types';
import { Variant } from 'theme/enums';

import { EditPartSetup } from './EditPartSetup';
import { isPartSetupEditable } from './utils';

interface IProps {
  part?: IPartDetails | null;
  manufacturer?: IPartManufacturer | null;
}

export const EditPartSetupButton = ({ part, manufacturer }: IProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const { t } = useTranslation();

  const { hasPermission } = useUserPermissions();

  const isEditable = isPartSetupEditable(
    part,
    manufacturer,
    hasPermission(AccessPermissions.PARTS_EDIT_SAVE_PARTICULARS)
  );

  if (!isEditable) {
    return null;
  }

  return (
    <>
      <Button
        startDecorator={<PencilSimple />}
        text={t('buttonLabelEdit')}
        variant={Variant.SOFT}
        onClick={() => setIsOpen(true)}
      />

      <EditPartSetup
        part={part}
        manufacturer={manufacturer}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      />
    </>
  );
};
